import '../../styles/index.css'
import './Produto.css';
import CardMaisPrecos from '../../components/Cards/CardMaisPrecos/CardMaisPrecos';
import TabelaDetalhes from '../../components/TabelaDetalhes/TabelaDetalhes';
import Carousel from '../../components/Carousels/CarouselFotos/CarouselFotos';
import ImagemExemplo from '../../assets/img/Imagem Exemplo.png'
import Location from '../../components/Location/Location';
import DescriçãoProduto from '../../components/DescriçãoProduto/DescriçãoProduto';
import CustomButton from '../../components/Buttons/CustomButton/CustomButton'
import BellVermelho from '../../assets/icons/Bell Icon.svg'
import ExternalPageButton from '../../assets/icons/External Page Icon Branco.svg'
import ModalNotificar from '../../components/Modals/ModalNotificar/ModalNotificar';
import { configs } from '../../utils/especificações';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiCategorias, apiUrl } from '../../api/api';
import { categoryFromAPI } from '../../utils/categoryFromAPI';

function Produto() {

  const { pesquisa, id } = useParams()
  const [nome, setNome] = useState()
  const [images, setImages] = useState([])
  const [preço, setPreço] = useState('')
  const [preçoParcelado, setPreçoParcelado] = useState('')
  const [link, setLink] = useState('')
  const [loja, setLoja] = useState('')
  const [lojas, setLojas] = useState([''])
  const [qtdOfertas, setQtdOfertas] = useState(0)
  const [tabelaArray, setTabelaArray] = useState([])

  useEffect(() => {

    if (Object.keys(categoryFromAPI).includes(pesquisa)) {

      apiCategorias.listaProdutoConfigs(pesquisa, id).then((response) => {
        console.log(response)

        mostrarDadosProduto(response)

        const respostas = filterResponse(response)
        setTabelaArray(configs[pesquisa].map((value, index) => respostas[index] ? [value, respostas[index]] : null).filter(value => value))
      })

    }

    else {

      apiUrl.listaConfigs(id).then((response) => {
        console.log(response)

        mostrarDadosProduto(response)

        const indices = Object.keys(response)
        const respostas = filterResponse(response)

        setTabelaArray(configs.qualConfig(indices).map((value, index) => respostas[index] ? [value, respostas[index]] : null).filter(value => value))
      })

    }


  }, [])

  const filterResponse = (response) => {

    const object = { ...response }
    delete object['stores']
    delete object['id']
    delete object['name']
    delete object['cache']
    delete object['images']
    delete object['url']
    return Object.values(object)
  }

  const mostrarDadosProduto = (response) => {

    const foto = response['images'].length !== 0 ? response['images'] : [ImagemExemplo]

    setImages(foto)
    setNome(response.name)

    const preços = []
    const preçosParcelado = []
    const stores = []
    const lojas = []
    const links = []
    let qtdOfertas = 0

    response.stores.forEach((loja, index) => {

      if (loja.stock_available === true) {
        stores.push(loja)
        links.push(loja.product_page_url)
        preços.push(parseFloat(loja.spot_price))
        preçosParcelado.push(loja.foward_price)
        lojas.push(loja.store)
        qtdOfertas += 1
      } else {
        delete response.stores[index]
      }

    })

    setLojas(stores)

    setQtdOfertas(qtdOfertas)

    const preço = Math.min(...preços)

    const preçoFormatado = preço.toString()

    setPreço(preçoFormatado)

    setPreçoParcelado(preçosParcelado[preços.indexOf(preço)])

    setLink(links[preços.indexOf(preço)])

    setLoja(lojas[preços.indexOf(preço)])
  }

  return (

    <>

      <ModalNotificar preçoAtual={preço} categoria={pesquisa} productID={id} />

      <main className='produto page-container'>

        <Location local={pesquisa} />

        <section className='secao-do-produto'>

          <div className='imagem-principal'>

            <Carousel images={images} />

            <p className='imagem-subtitle c1'>{`Ofertado por: ${loja}`}</p>
          </div>

          <div className='info-principal'>

            <div>
              <DescriçãoProduto nome={nome} preço={preço} preçoParcelado={preçoParcelado} qtdOfertas={qtdOfertas} />
            </div>

            <div className='botoes-do-principal'>

              <div data-bs-toggle="modal" data-bs-target="#modalNotificar">
                <CustomButton texto='Criar Alerta' cor='white' tipo='2' icone={BellVermelho} />
              </div>

              <a href={link}>
                <CustomButton texto='Ver Oferta' cor='#A80A01' tipo='2' icone={ExternalPageButton} />
              </a>

            </div>

          </div>

        </section>

        <section className='secao-mais-precos' id='secao-mais-precos'>
          <h6>Preços Deste Produto:</h6>
          <div className='mais-precos'>

            {

              lojas.length > 1 ? lojas.map((store, index) => {

                return store && store.store !== loja && <CardMaisPrecos key={store.id} imagem={images[0]} preço={store.spot_price} preçoParcelado={store.foward_price} loja={store.store} link={store.product_page_url} />

              }) : <p className='b2 py-4'>Não há outras lojas ofertando este produto.</p>

            }

          </div>

        </section>

        <section className='secao-tabela-de-detalhes'>
          <h6>Detalhes do Produto:</h6>
          <TabelaDetalhes arrayTabela={tabelaArray} />
        </section>

      </main>

    </>
  );
}

export default Produto;
